// extracted by mini-css-extract-plugin
module.exports = {"path":"renewMap_path__1CLth","text":"renewMap_text__2ujhI"};